import { femaleQuestionMedium, maleQuestionMedium, bulbMedium } from '@/assets/icons';

const FIVE_WHYS = `
<h2 class="basic-sub-title">
  Find the root cause
</h2>
<p>
  The 'five whys' tool is used in problem solving to determine the root cause of a problem.
  Identifying the root cause of a problem allows the team to plan effective corrective actions in order
  to permanently eliminate the root cause of the problem. Eliminating the root cause should
  <strong>prevent any recurrence</strong> of the problem, even though that means taking the time to seek it first.<br>
</p>
<br>
<div class="ia-sensei-question">
  <div class="question-decoration"></div>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path d="${femaleQuestionMedium}"></path></svg>
  <span class="question">Ok, but if a problem happens during production, I need to fix it right away. I don't have time to search for the root cause.</span>
</div>
<br>
<p>
  Fair enough, you must, indeed, do whatever you can in order to keep the production going.
  But a problem happened and it needs to be solved permanently. The actions you carried out
  to keep it going may not be solving actions, they are what we call 'immediate countermeasures'
  or 'securing actions' and they only fix the symptoms of the problem.<br>
  Later this day, or the day after, the team should have a look at the problem using the 'five whys' tool.
</p>
<div class="ia-sensei-example">
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path d="${bulbMedium}"></path></svg>
  <div class="example-title">Let's take the fuse example :</div>
  An essential production machine just stopped.<br>
  <i>1. Why did the machine stop?</i><br>There was an overload and the fuse blew.<br>
  <i>2. Why did the overload happen?</i><br>One of the cooling bearing wasn't lubricated enough which slowed down the cooling.<br>
  <i>3. Why wasn't the bearing lubricated enough?</i><br>The lubrication pump was too slow.<br>
  <i>4. Why was the pump slow?</i><br>The shaft of the pump was worn and rattling because of metal scraps.<br>
  <i>5. Why was there metal scraps hitting the shaft?</i><br>The pump needs a proper strainer and there wasn't one.<br>
</div>
<p>
  When considering this example, it is pretty clear that without further investigation
  and without the use of the 'five whys' tool, the overload would regularly happen again.
  The purpose of the five whys is to identify one root cause to eliminate so that
  the problem never happens again to your team or any other team.<br>
  Shizen's 'Five Whys' is a great place to carry out this investigation.
</p>
<h2 class="basic-sub-title">
  Identify true causes
</h2>
<p>
  Just like when reporting problems, you need to make sure that the causes are real.
  And more importantly, you must use specific data to prove it. To do that, Shizen allows you to take pictures
  or to add other types of files as attachments to the cause.<br>
  In the example above, most of the identified causes require a picture.<br><br>
  You will quickly learn more about the 'five whys' tool by testing it.
  Feel free to have a look at the 'Ishikawa' tool as well.
  The causes you add in one tool will appear in the other.
</p>
`;

const FIVE_WHYS_TITLE = '5 whys';

export default {
  FIVE_WHYS,
  FIVE_WHYS_TITLE,
};
